export const PAGE_NAMES = {
    HOME: 'Home',
    CURRENCY: 'Currency',
    CONTACT: 'Contact Us',
    BLOG: 'Blog',
    FAQ: 'Faq',
    ABOUT: 'About Us',
    PRIVACY_POLICY: 'Privacy Policy',
    TERMS_OF_SERVICE: 'Terms Of Service',
    COPYRIGHT_POLICY: 'Copyright Policy',
    CART: 'Cart',
    CUSTOMER_PORTAL: 'Customer Portal',
    EXPIRED_LINK: 'Expired Link',
    ORDER_DETAILS: 'Order Details',
    BUG_BOUNTY: 'Bug Bounty',
    SITEMAP: 'Sitemap',
    SUPPORT: 'Support',
    AUTH: 'Auth',
    UNKNOWN_ROUTE: '404',
};

export const DEVICES = {
    SMALL_PHONE: 320,
    SMALL_PHONE_PLUS: 375,
    MEDIUM_PHONE: 425,
    PHONE: 576,
    AUTH_PHONE: 675,
    SMALL_TABLET: 720,
    TABLET: 768,
    DESKTOP: 992,
    LAPTOP: 1024,
    MEDIUM_DESKTOP: 1080,
    WIDESCREEN: 1200,
    WIDESCREEN_PLUS: 1235,
    LAPTOP_LARGE: 1440,
    EXTRA_SCREEN: 1500,
    EXTRA_LARGE_PLUS_SCREEN: 1920,
    EXTRA_LARGE_SCREEN: 3840,
};

export const SortArr = [
    {
        label: 'Popular',
        value: 'popular',
        selected: true
    },
    {
        label: 'Newest',
        value: 'newest',
        selected: false
    },
    {
        label: 'Alphabetical',
        value: 'title',
        selected: false
    },
    {
        label: 'Oldest',
        value: 'oldest',
        selected: false
    },
];

export const currencyItems = [
    { text: 'Moroccan Dirham', value: 'MAD' },
    { text: 'BNB', value: 'BNB' },
    { text: 'Bitcoin', value: 'BTC' },
    { text: 'Ethereum', value: 'ETH' },
    { text: 'Monero', value: 'XMR' },
    { text: 'Litecoin', value: 'LTC' },
    { text: 'USDT', value: 'USDT' },
    { text: 'USDC', value: 'USDC' },
    { text: 'Bitcoin Cash', value: 'BCH' },
    { text: 'Dash', value: 'DASH' },
    { text: 'Ethereum Classic', value: 'ETC' },
    { text: 'Solana', value: 'SOL' },
    { text: 'Polkadot', value: 'DOT' },
    { text: 'Shiba Inu', value: 'SHIB' },
    { text: 'Uniswap', value: 'UNI' },
    { text: 'Stellar', value: 'XLM' },
    { text: 'Lido DAO Token', value: 'LDO' },
    { text: 'Hedera', value: 'HBAR' },
    { text: 'Aptos', value: 'APT' },
    { text: 'Arbitrum', value: 'ARB' },
    { text: 'Quant', value: 'QNT' },
    { text: 'VeChain', value: 'VET' },
    { text: 'Stacks', value: 'STX' },
    { text: 'The Graph', value: 'GRT' },
    { text: 'Optimism', value: 'OP' },
    { text: 'ApeCoin', value: 'APE' },
    { text: 'MultiversX', value: 'EGLD' },
    { text: 'Fantom', value: 'FTM' },
    { text: 'Rocket Pool', value: 'RPL' },
    { text: 'Chainlink', value: 'LINK' },
    { text: 'Dogecoin', value: 'DOGE' },
    { text: 'TRON', value: 'TRX' },
    { text: 'US Dollar', value: 'USD' },
    { text: 'CA Dollar', value: 'CAD' },
    { text: 'EU Euro', value: 'EUR' },
    { text: 'AU Dollar', value: 'AUD' },
    { text: 'GB Pound', value: 'GBP' },
    { text: 'NZ Dollar', value: 'NZD' },
    { text: 'NO Krone', value: 'NOK' },
    { text: 'SE Krona', value: 'SEK' },
    { text: 'CH Franc', value: 'CHF' },
    { text: 'DK Krone', value: 'DKK' },
    { text: 'BR Real', value: 'BRL' },
    { text: 'JP Yen', value: 'JPY' },
    { text: 'CN Yuan', value: 'CNY' },
    { text: 'TH Baht', value: 'THB' },
    { text: 'Indian Rupee', value: 'INR' },
    { text: 'Mexican Peso', value: 'MXN' },
    { text: 'Malaysian Ringgit', value: 'MYR' },
    { text: 'Philippine Peso', value: 'PHP' }
];

export const LanguageAbbreviations = [
    { name: 'Afar', abbreviation: 'AFR' },
    { name: 'Abkhazian', abbreviation: 'ABK' },
    { name: 'Avestan', abbreviation: 'AVE' },
    { name: 'Afrikaans', abbreviation: 'AFR' },
    { name: 'Akan', abbreviation: 'AKA' },
    { name: 'Amharic', abbreviation: 'AMH' },
    { name: 'Aragonese', abbreviation: 'ARG' },
    { name: 'Arabic', abbreviation: 'ARA' },
    { name: 'Assamese', abbreviation: 'ASM' },
    { name: 'Avaric', abbreviation: 'AVA' },
    { name: 'Aymara', abbreviation: 'AYM' },
    { name: 'Azerbaijani', abbreviation: 'AZE' },
    { name: 'Bashkir', abbreviation: 'BAK' },
    { name: 'Belarusian', abbreviation: 'BEL' },
    { name: 'Bulgarian', abbreviation: 'BUL' },
    { name: 'Bihari Languages', abbreviation: 'BIH' },
    { name: 'Bislama', abbreviation: 'BIS' },
    { name: 'Bambara', abbreviation: 'BAM' },
    { name: 'Bengali', abbreviation: 'BEN' },
    { name: 'Tibetan', abbreviation: 'TIB' },
    { name: 'Breton', abbreviation: 'BRE' },
    { name: 'Bosnian', abbreviation: 'BOS' },
    { name: 'Catalan', abbreviation: 'CAT' },
    { name: 'Chechen', abbreviation: 'CHE' },
    { name: 'Chamorro', abbreviation: 'CHA' },
    { name: 'Chinese', abbreviation: 'CHN' },
    { name: 'Corsican', abbreviation: 'COS' },
    { name: 'Cree', abbreviation: 'CRE' },
    { name: 'Czech', abbreviation: 'CES' },
    { name: 'Old Slavonic', abbreviation: 'CHU' },
    { name: 'Chuvash', abbreviation: 'CHV' },
    { name: 'Welsh', abbreviation: 'CYM' },
    { name: 'Danish', abbreviation: 'DAN' },
    { name: 'German', abbreviation: 'DEU' },
    { name: 'Divehi', abbreviation: 'DIV' },
    { name: 'Dzongkha', abbreviation: 'DZO' },
    { name: 'Ewe', abbreviation: 'EWE' },
    { name: 'Greek', abbreviation: 'ELL' },
    { name: 'English', abbreviation: 'ENG' },
    { name: 'Esperanto', abbreviation: 'EPO' },
    { name: 'Spanish', abbreviation: 'ESP' },
    { name: 'Estonian', abbreviation: 'EST' },
    { name: 'Basque', abbreviation: 'EUS' },
    { name: 'Persian', abbreviation: 'FAS' },
    { name: 'Fulah', abbreviation: 'FUL' },
    { name: 'Finnish', abbreviation: 'FIN' },
    { name: 'Fijian', abbreviation: 'FIJ' },
    { name: 'Faroese', abbreviation: 'FRO' },
    { name: 'French', abbreviation: 'FRA' },
    { name: 'Western Frisian', abbreviation: 'FRY' },
    { name: 'Irish', abbreviation: 'GLE' },
    { name: 'Gaelic Gaelic', abbreviation: 'GLA' },
    { name: 'Galician', abbreviation: 'GLG' },
    { name: 'Manx', abbreviation: 'GLV' },
    { name: 'Guarani', abbreviation: 'GRN' },
    { name: 'Gujarati', abbreviation: 'GUJ' },
    { name: 'Haitian Creole', abbreviation: 'HAT' },
    { name: 'Hausa', abbreviation: 'HAU' },
    { name: 'Hebrew', abbreviation: 'HEB' },
    { name: 'Herero', abbreviation: 'HER' },
    { name: 'Hindi', abbreviation: 'HIN' },
    { name: 'Hiri Motu', abbreviation: 'HMO' },
    { name: 'Croatian', abbreviation: 'HRV' },
    { name: 'Hungarian', abbreviation: 'HUN' },
    { name: 'Armenian', abbreviation: 'HYE' },
    { name: 'Interlingua', abbreviation: 'INA' },
    { name: 'Indonesian', abbreviation: 'IND' },
    { name: 'Interlingue', abbreviation: 'ILE' },
    { name: 'Igbo', abbreviation: 'IBO' },
    { name: 'Sichuan Yi', abbreviation: 'III' },
    { name: 'Inupiaq', abbreviation: 'IPK' },
    { name: 'Ido', abbreviation: 'IDO' },
    { name: 'Icelandic', abbreviation: 'ISL' },
    { name: 'Italian', abbreviation: 'ITA' },
    { name: 'Inuktitut', abbreviation: 'IKU' },
    { name: 'Japanese', abbreviation: 'JPN' },
    { name: 'Javanese', abbreviation: 'JAV' },
    { name: 'Georgian', abbreviation: 'KAT' },
    { name: 'Kongo', abbreviation: 'KON' },
    { name: 'Kikuyu', abbreviation: 'KIK' },
    { name: 'Kuanyama', abbreviation: 'KUA' },
    { name: 'Kazakh', abbreviation: 'KAZ' },
    { name: 'Kalaallisut', abbreviation: 'KAL' },
    { name: 'Central Khmer', abbreviation: 'KHM' },
    { name: 'Kannada', abbreviation: 'KAN' },
    { name: 'Korean', abbreviation: 'KOR' },
    { name: 'Kanuri', abbreviation: 'KAU' },
    { name: 'Kashmiri', abbreviation: 'KAS' },
    { name: 'Kurdish', abbreviation: 'KUR' },
    { name: 'Komi', abbreviation: 'KOM' },
    { name: 'Cornish', abbreviation: 'COR' },
    { name: 'Kirghiz', abbreviation: 'KIR' },
    { name: 'Latin', abbreviation: 'LAT' },
    { name: 'Luxembourgish', abbreviation: 'LTZ' },
    { name: 'Ganda', abbreviation: 'LUG' },
    { name: 'Limburgan', abbreviation: 'LIM' },
    { name: 'Lingala', abbreviation: 'LIN' },
    { name: 'Lao', abbreviation: 'LAO' },
    { name: 'Lithuanian', abbreviation: 'LIT' },
    { name: 'Luba-Katanga', abbreviation: 'LUB' },
    { name: 'Latvian', abbreviation: 'LAV' },
    { name: 'Malagasy', abbreviation: 'MLG' },
    { name: 'Marshallese', abbreviation: 'MAH' },
    { name: 'Maori', abbreviation: 'MRI' },
    { name: 'Macedonian', abbreviation: 'MKD' },
    { name: 'Malayalam', abbreviation: 'MAL' },
    { name: 'Mongolian', abbreviation: 'MON' },
    { name: 'Marathi', abbreviation: 'MAR' },
    { name: 'Malay', abbreviation: 'MSA' },
    { name: 'Maltese', abbreviation: 'MLT' },
    { name: 'Burmese', abbreviation: 'MYA' },
    { name: 'Nauru', abbreviation: 'NAU' },
    { name: 'Navajo', abbreviation: 'NAV' },
    { name: 'Ndebele', abbreviation: 'NBL' },
    { name: 'Nepali', abbreviation: 'NEP' },
    { name: 'Ndonga', abbreviation: 'NDO' },
    { name: 'Dutch', abbreviation: 'NLD' },
    { name: 'Norwegian', abbreviation: 'NNO' },
    { name: 'BokmÃ¥l', abbreviation: 'NOB' },
    { name: 'Norwegian', abbreviation: 'NOR' },
    { name: 'Chichewa', abbreviation: 'NYA' },
    { name: 'Occitan', abbreviation: 'OCI' },
    { name: 'Ojibwa', abbreviation: 'OJI' },
    { name: 'Oriya', abbreviation: 'ORI' },
    { name: 'Oromo', abbreviation: 'ORM' },
    { name: 'Ossetian', abbreviation: 'OSS' },
    { name: 'Panjabi', abbreviation: 'PAN' },
    { name: 'Pali', abbreviation: 'PAL' },
    { name: 'Polish', abbreviation: 'POL' },
    { name: 'Pushto', abbreviation: 'PUS' },
    { name: 'Portuguese', abbreviation: 'POR' },
    { name: 'Quechua', abbreviation: 'QUE' },
    { name: 'Romansh', abbreviation: 'ROH' },
    { name: 'Rundi', abbreviation: 'RUN' },
    { name: 'Romanian', abbreviation: 'RON' },
    { name: 'Russian', abbreviation: 'RUS' },
    { name: 'Kinyarwanda', abbreviation: 'KIN' },
    { name: 'Sanskrit', abbreviation: 'SAN' },
    { name: 'Sardinian', abbreviation: 'SRD' },
    { name: 'Sindhi', abbreviation: 'SND' },
    { name: 'Northern Sami', abbreviation: 'SME' },
    { name: 'Samoan', abbreviation: 'SMO' },
    { name: 'Sango', abbreviation: 'SAG' },
    { name: 'Serbian', abbreviation: 'SRP' },
    { name: 'Shona', abbreviation: 'SHN' },
    { name: 'Sichuan Yi', abbreviation: 'III' },
    { name: 'Sindhi', abbreviation: 'SND' },
    { name: 'Sinhala', abbreviation: 'SIN' },
    { name: 'Slovak', abbreviation: 'SLK' },
    { name: 'Slovenian', abbreviation: 'SLV' },
    { name: 'Northern Sami', abbreviation: 'SME' },
    { name: 'Samoan', abbreviation: 'SMO' },
    { name: 'Sango', abbreviation: 'SAG' },
    { name: 'Serbian', abbreviation: 'SRP' },
    { name: 'Gaelic', abbreviation: 'GLE' },
    { name: 'Shona', abbreviation: 'SHN' },
    { name: 'Sindhi', abbreviation: 'SND' },
    { name: 'Sinhala', abbreviation: 'SIN' },
    { name: 'Slovak', abbreviation: 'SLK' },
    { name: 'Slovenian', abbreviation: 'SLV' },
    { name: 'Somali', abbreviation: 'SOM' },
    { name: 'Sotho, Southern', abbreviation: 'SOT' },
    { name: 'Spanish', abbreviation: 'SPA' },
    { name: 'Sardinian', abbreviation: 'SRD' },
    { name: 'Sindhi', abbreviation: 'SND' },
    { name: 'Northern Sami', abbreviation: 'SME' },
    { name: 'Samoan', abbreviation: 'SMO' },
    { name: 'Sango', abbreviation: 'SAG' },
    { name: 'Serbian', abbreviation: 'SRP' },
    { name: 'Gaelic', abbreviation: 'GLE' },
    { name: 'Shona', abbreviation: 'SHN' },
    { name: 'Sindhi', abbreviation: 'SND' },
    { name: 'Sinhala', abbreviation: 'SIN' },
    { name: 'Slovak', abbreviation: 'SLK' },
    { name: 'Slovenian', abbreviation: 'SLV' },
    { name: 'Somali', abbreviation: 'SOM' },
    { name: 'Sotho, Southern', abbreviation: 'SOT' },
    { name: 'Spanish', abbreviation: 'SPA' },
    { name: 'Sundanese', abbreviation: 'SUN' },
    { name: 'Swahili', abbreviation: 'SWA' },
    { name: 'Swati', abbreviation: 'SSW' },
    { name: 'Swedish', abbreviation: 'SWE' },
    { name: 'Tahitian', abbreviation: 'TAH' },
    { name: 'Tamil', abbreviation: 'TAM' },
    { name: 'Tatar', abbreviation: 'TAT' },
    { name: 'Telugu', abbreviation: 'TEL' },
    { name: 'Tajik', abbreviation: 'TGK' },
    { name: 'Tagalog', abbreviation: 'TLG' },
    { name: 'Thai', abbreviation: 'THA' },
    { name: 'Tibetan', abbreviation: 'TIB' },
    { name: 'Tigrinya', abbreviation: 'TIR' },
    { name: 'Tonga', abbreviation: 'TON' },
    { name: 'Tswana', abbreviation: 'TSN' },
    { name: 'Tsonga', abbreviation: 'TSO' },
    { name: 'Turkmen', abbreviation: 'TUK' },
    { name: 'Turkish', abbreviation: 'TUR' },
    { name: 'Tatar', abbreviation: 'TAT' },
    { name: 'Tajik', abbreviation: 'TGK' },
    { name: 'Tagalog', abbreviation: 'TLG' },
    { name: 'Thai', abbreviation: 'THA' },
    { name: 'Tibetan', abbreviation: 'TIB' },
    { name: 'Tigrinya', abbreviation: 'TIR' },
    { name: 'Tonga', abbreviation: 'TON' },
    { name: 'Tswana', abbreviation: 'TSN' },
    { name: 'Tsonga', abbreviation: 'TSO' },
    { name: 'Turkmen', abbreviation: 'TUK' },
    { name: 'Turkish', abbreviation: 'TUR' },
    { name: 'Twi', abbreviation: 'TWI' },
    { name: 'Uighur', abbreviation: 'UIG' },
    { name: 'Ukrainian', abbreviation: 'UKR' },
    { name: 'Urdu', abbreviation: 'URD' },
    { name: 'Uzbek', abbreviation: 'UZB' },
    { name: 'Venda', abbreviation: 'VEN' },
    { name: 'Vietnamese', abbreviation: 'VIE' },
    { name: 'VolapÃ¼k', abbreviation: 'VOL' },
    { name: 'Walloon', abbreviation: 'WLN' },
    { name: 'Wolof', abbreviation: 'WOL' },
    { name: 'Xhosa', abbreviation: 'XHO' },
    { name: 'Yiddish', abbreviation: 'YID' },
    { name: 'Yoruba', abbreviation: 'YOR' },
    { name: 'Zhuang', abbreviation: 'ZHA' },
    { name: 'Zulu', abbreviation: 'ZUL' }
];
